<template>
  <div style="height:100%">
    <el-card style="height:100%;width: 55%;display: flex;flex-direction: column;">
      <div slot="header" class="clearfix">
        <i class="el-icon-s-grid"></i><span class="ml-1">部件类别管理</span>
        <el-button :type="'primary'" :icon="'el-icon-document-add'" size="mini" class="ml-3" @click="addFirst">新建大类
        </el-button>
        <el-button :type="'danger'" :icon="'el-icon-delete'" size="mini" class="ml-2" @click="deleteData">删除
        </el-button>
        <el-button :icon="'el-icon-refresh'" size="mini" class="ml-2" @click="getAllData">刷新
        </el-button>
      </div>
      <div style="height:100%; overflow-y:auto">
        <el-tree ref="tree" :data="dataList" node-key="id" check-strictly default-expand-all show-checkbox highlight-current
          :expand-on-click-node="false">
          <span class="custom-tree-node" slot-scope="{ node, data }">
            <span>{{ node.label }}</span>
            <span>
              <el-button type="text" size="small" @click="() => editCurrent(node, data)">
                编辑
              </el-button>
              <el-button type="text" size="small" @click="() => addChildren(node,data)">
                添加子类
              </el-button>
            </span>
          </span>
        </el-tree>
      </div>
    </el-card>
    <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="30%">
      <b-row>
        <b-col sm="6">
          类别名称：<el-input clearable v-model="typeModel.text"></el-input>
        </b-col>
        <b-col sm="6">
          分类码：<el-input clearable v-model="typeModel.type_code"></el-input>
        </b-col>
      </b-row>
      <b-row class="mt-2">
        <b-col sm="12">
          备注：<el-input type="textarea" clearable v-model="typeModel.remark"></el-input>
        </b-col>
      </b-row>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="saveData">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import * as ProductPartsTypeController from "../../controllers/base/ProductPartsTypeController";
export default {
  components: {
  },
  data() {
    return {
      dataList: [],
      dialogTitle: "部件大类",
      dialogVisible: false,
      typeModel: {
        id: "",
        type_code: "",
        text: "", //类别名称
        parent_id: 0,
        remark: "" //备注
      },
      action_node: null,
      selectedNodes: []
    }
  },
  mounted() {
    this.getAllData()
  },
  methods: {
    async getAllData() {
      this.dataList = []
      let _result = await ProductPartsTypeController.methods.getData({
        is_deleted: { "=": 0 },
      });
      if (!_.isNull(_result) && _result && _result.length > 0) {
        console.log(_result[0])
        this.setChild(_result[0], 0)
      }
    },
    setChild(data, pid, baseItem) {
      let _level1 = _.filter(data, { parent_id: pid });
      if (_level1 && _level1.length > 0) {
        for (var i in _level1) {
          let _m = _level1[i];
          let item = {
            id: _m.id,
            label: _m.text,
            text: _m.text,
            type_code: _m.type_code,
            children: [],
            parent_id: _m.parent_id,

          };
          if (baseItem) {
            baseItem.children.push(item);
          } else {
            this.dataList.push(item);
          }
          this.setChild(data, _m.id, item);
        }
      }
    },
    addFirst() {
      this.dialogTitle = "新建部件大类"
      this.dialogVisible = true
    },
    editCurrent(node) {
      this.action_node = node
      Object.assign(this.typeModel, _.cloneDeep(node.data))
      this.dialogTitle = "编辑当前项";
      this.dialogVisible = true
    },
    addChildren(node, data) {
      console.log(node)
      this.clearModel()
      this.action_node = node
      this.typeModel.parent_id = data.id
      this.dialogTitle = "添加当前类别子类"
      this.dialogVisible = true
    },
    async saveData() {
      if (this.typeModel.text == "") {
        this.msgToasts("请输入类别名称!", "info");
        return;
      }
      let p = _.cloneDeep(this.typeModel)
      if (p.id != "") {
        delete p.children
        delete p.label
      }

      let rt = await ProductPartsTypeController.methods.saveData(p);
      if (rt && rt.length > 0 && rt[0] && rt[0].Result && rt[0].Result.Data) {
        let m = _.cloneDeep(rt[0].Result.Data[0][0]);
        m.label = m.text
        if (this.typeModel.id == "") {
          if (m.parent_id != 0) {
            this.action_node.data.children.push(m)
          }
          else {
            this.dataList.push(m);
          }
        }
        else {
          this.action_node.data.label = m.text
          this.action_node.data.remark = m.remark
          this.action_node.data.type_code = m.type_code
        }

        this.msgToasts(this.$t("notify.action_successfully"), "success");
        this.dialogVisible = false
      }
      console.log(rt)
      this.clearModel()
    },
    async deleteData() {
      let _dt = [];
      let ct = this.$refs.tree.getCheckedNodes()
      if (ct.length == 0) {
        this.$msgNotify("请选择!", "warning");
        return;
      }

      let is_ok = await this.msgModal(this.$t("notify.is_deleted"));
      if (!is_ok) {
        return
      }
      if (ct.length > 0) {
        for (var i in ct) {
          _dt.push({ id: ct[i].id });
        }
      }

      let result = await ProductPartsTypeController.methods.deleteData(_dt)
      if (result && result.length > 0) {

        _.each(ct, (t) => {
          this.$refs.tree.remove(t)
        })
        this.msgNotify(this.$t("notify.action_successfully"), "success")
      }
      else {
        this.msgNotify(this.$t("notify.action_unsuccessfully"), "info")
      }
    },
    clearModel() {
      this.typeModel = {
        id: "",
        type_code: "",
        text: "", //类别名称
        parent_id: 0,
        remark: "" //备注
      }
    }
  }
}
</script>
<style scoped>
.el-tree {
  max-height: 35rem;
}
.custom-tree-node {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 14px;
  padding-right: 8px;
}
.custom-control-input:checked ~ .custom-control-label::before {
  color: #fff;
  border-color: #409eff;
  background-color: #409eff;
}

.el-card :deep(.el-card__body){
  flex: 1 ;
}
</style>
